import {
  JobCandidateHiringStep,
  JobCandidateStatus,
  JobCandidateStatusReason,
  SourcingChannel,
} from '@/gql/graphql'
import { $t } from '@/composables/translation'

// Hire flows
export enum JOB_FLOW {
  BROADCAST = 'broadcast',
  DIRECT_HIRE = 'direct-hire',
}

export enum JOB_TAB {
  OVERVIEW = 'overview',
  DETAILS = 'details',
  BUDGET = 'budget',
  SETTINGS = 'settings',
}

export enum BUDGET_TYPE {
  SPECIFIC_RATE = 'specific-rate',
  RATE_RANGE = 'rate-range',
}

export const JobCandidateStatusList = {
  [JobCandidateStatus.Eligible]: {
    label: $t('Eligible'),
    value: JobCandidateStatus.Eligible,
  },
  [JobCandidateStatus.NonEligible]: {
    label: $t('Non-Eligible'),
    value: JobCandidateStatus.NonEligible,
  },
  [JobCandidateStatus.Duplicate]: {
    label: $t('Duplicate'),
    value: JobCandidateStatus.Duplicate,
  },
}

export const JobCandidateStatusListArray = [
  JobCandidateStatusList[JobCandidateStatus.Eligible],
  JobCandidateStatusList[JobCandidateStatus.NonEligible],
  JobCandidateStatusList[JobCandidateStatus.Duplicate],
]

export const JobCandidateStepList = {
  [JobCandidateHiringStep.Shortlisted]: {
    label: $t('Shortlisted'),
    value: JobCandidateHiringStep.Shortlisted,
  },
  [JobCandidateHiringStep.InvitedToApply]: {
    label: $t('Invited to apply'),
    value: JobCandidateHiringStep.InvitedToApply,
  },
  [JobCandidateHiringStep.Applied]: {
    label: $t('Applied'),
    value: JobCandidateHiringStep.Applied,
  },
  [JobCandidateHiringStep.Hiring]: {
    label: $t('Hiring'),
    value: JobCandidateHiringStep.Hiring,
  },
}

export const JobCandidateStepListArray = [
  JobCandidateStepList[JobCandidateHiringStep.Shortlisted],
  JobCandidateStepList[JobCandidateHiringStep.InvitedToApply],
  JobCandidateStepList[JobCandidateHiringStep.Applied],
  JobCandidateStepList[JobCandidateHiringStep.Hiring],
]

export const SourcingChannelList = {
  [SourcingChannel.Marketplace]: {
    label: $t('Marketplace'),
    value: SourcingChannel.Marketplace,
  },
  [SourcingChannel.TrustedContact]: {
    label: $t('Trusted Contact'),
    value: SourcingChannel.TrustedContact,
  },
  [SourcingChannel.CandidateSubmission]: {
    label: $t('Candidate Submission'),
    value: SourcingChannel.CandidateSubmission,
  },
  [SourcingChannel.RecruiterAttribution]: {
    label: $t('Recruiter Attribution'),
    value: SourcingChannel.RecruiterAttribution,
  },
}

export const SourcingChannelListArray = [
  SourcingChannelList[SourcingChannel.Marketplace],
  SourcingChannelList[SourcingChannel.TrustedContact],
  SourcingChannelList[SourcingChannel.CandidateSubmission],
  SourcingChannelList[SourcingChannel.RecruiterAttribution],
]

export const JobCandidateStatusReasonList = {
  [JobCandidateStatusReason.SkillsOrExperience]: {
    label: $t('Skills or experience'),
    value: JobCandidateStatusReason.SkillsOrExperience,
  },
  [JobCandidateStatusReason.SpecificJobCriteria]: {
    label: $t('Specific job criteria'),
    value: JobCandidateStatusReason.SpecificJobCriteria,
  },
  [JobCandidateStatusReason.Availability]: {
    label: $t('Availability'),
    value: JobCandidateStatusReason.Availability,
  },
  [JobCandidateStatusReason.MarketEligibility]: {
    label: $t('Market eligibility'),
    value: JobCandidateStatusReason.MarketEligibility,
  },
  [JobCandidateStatusReason.Budget]: {
    label: $t('Budget'),
    value: JobCandidateStatusReason.Budget,
  },
  [JobCandidateStatusReason.AcceptedOtherJob]: {
    label: $t('Accepted other job'),
    value: JobCandidateStatusReason.AcceptedOtherJob,
  },
  [JobCandidateStatusReason.OtherCandidateAccepted]: {
    label: $t('Other candidate accepted'),
    value: JobCandidateStatusReason.OtherCandidateAccepted,
  },
  [JobCandidateStatusReason.AddedByMistake]: {
    label: $t('Added by mistake'),
    value: JobCandidateStatusReason.AddedByMistake,
  },
  [JobCandidateStatusReason.ExistingApplicationThroughOtherChannels]: {
    label: $t('Existing application through other channels'),
    value: JobCandidateStatusReason.ExistingApplicationThroughOtherChannels,
  },
}

export const JobCandidateStatusReasonListArray = [
  JobCandidateStatusReasonList[JobCandidateStatusReason.SkillsOrExperience],
  JobCandidateStatusReasonList[JobCandidateStatusReason.SpecificJobCriteria],
  JobCandidateStatusReasonList[JobCandidateStatusReason.Availability],
  JobCandidateStatusReasonList[JobCandidateStatusReason.MarketEligibility],
  JobCandidateStatusReasonList[JobCandidateStatusReason.Budget],
  JobCandidateStatusReasonList[JobCandidateStatusReason.AcceptedOtherJob],
  JobCandidateStatusReasonList[JobCandidateStatusReason.OtherCandidateAccepted],
  JobCandidateStatusReasonList[JobCandidateStatusReason.AddedByMistake],
  JobCandidateStatusReasonList[JobCandidateStatusReason.ExistingApplicationThroughOtherChannels],
]
